import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { first } from 'rxjs/operators';
import { User } from 'src/app/model/user.model';
import { TranslationService } from 'src/app/service/translate.service';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  private formSubmitAttempt: boolean;
  error = '';
  returnUrl: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    public translationService: TranslationService,
    private translationPipe: TranslationPipe) {
    if (this.authService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  isFieldInvalid(field: string) {
    return (!this.form.get(field).valid && this.form.get(field).touched) || (this.form.get(field).untouched && this.formSubmitAttempt);
  }

  onSubmit() {
    if (this.form.valid){
    this.authService.login(this.form.value.userName, this.form.value.password)
    .pipe(first())
    .subscribe(
        data => {
            this.router.navigate([this.returnUrl]);
        },
        error => {
          this.error = this.translationPipe.transform(error);
        });
  }}

  register() {
    this.router.navigateByUrl('/register');

  }

  changeLang() {
    this.translationService.changeLang();
  }

}
